import { Toast } from 'antd-mobile';
import {
  incomeShowInfo,
  productList,
  getDiamondExchangeInfo,
  diamondExchangeCoins,
  recentlyUsed,
  payoutchannelList,
  channelSelect,
  payoutSubmit,
  recordList,
  getShowTask,
  getGuidanceTask,
  getAnchorLevelInfo
} from '@/services/api';

const withdraw = {
  namespace: 'withdraw',
  state: {
    productList: [],
    incomeShowInfo: {},
    diamondExchangeInfo: {},
    recentlyUsed: {},
    payoutchannelList: [],
    guidanceTask: null,
    anchorLevelInfo: null
  },
  reducers: {
    updateProductList(state, { payload }) {
      return {
        ...state,
        productList: payload
      };
    },
    updateIncomeShowInfo(state, { payload }) {
      return {
        ...state,
        incomeShowInfo: payload
      };
    },
    updateDiamondExchangeInfo(state, { payload }) {
      return {
        ...state,
        diamondExchangeInfo: payload
      };
    },
    updateRecentlyUsed(state, { payload }) {
      return {
        ...state,
        recentlyUsed: payload
      };
    },
    updatePayoutchannelList(state, { payload }) {
      return {
        ...state,
        payoutchannelList: payload
      };
    },
    updateGuidanceTask(state, { payload }) {
      return {
        ...state,
        guidanceTask: payload
      };
    },
    updateAnchorLevelInfo(state, { payload }) {
      return {
        ...state,
        anchorLevelInfo: payload
      };
    }
  },
  effects: {
    *productList({ payload }, { call, put }) {
      const { error, data } = yield call(productList, payload);
      console.log(error, data, 'productList');
      if (error) {
        Toast.show({
          content: error
        });
        return;
      }
      yield put({
        type: 'updateProductList',
        payload: data
      });
      return data;
    },
    *incomeShowInfo({ payload }, { call, put }) {
      const { error, data } = yield call(incomeShowInfo, payload);
      if (error) {
        Toast.show({
          content: error
        });
        return;
      }
      yield put({
        type: 'updateIncomeShowInfo',
        payload: data
      });
      return data;
    },
    *getDiamondExchangeInfo({ payload }, { call, put }) {
      const { error, data } = yield call(getDiamondExchangeInfo, payload);
      if (error) {
        Toast.show({
          content: error
        });
        return;
      }
      yield put({
        type: 'updateDiamondExchangeInfo',
        payload: data
      });
      return data;
    },
    *diamondExchangeCoins({ payload }, { call }) {
      const res = yield call(diamondExchangeCoins, payload);
      // if (error) {
      //   Toast.show({
      //     content: error
      //   });
      //   return false;
      // }
      return res;
    },
    *recentlyUsed({ payload }, { call, put }) {
      const { error, data } = yield call(recentlyUsed, payload);
      if (error) {
        Toast.show({
          content: error
        });
        return false;
      }
      yield put({
        type: 'updateRecentlyUsed',
        payload: data
      });
      return data;
    },
    *payoutchannelList({ payload }, { call, put }) {
      const { error, data } = yield call(payoutchannelList, payload);
      if (error) {
        Toast.show({
          content: error
        });
      }
      yield put({
        type: 'updatePayoutchannelList',
        payload: data
      });
      return data;
    },
    *channelSelect({ payload }, { call }) {
      const { error, data } = yield call(channelSelect, payload);
      if (error) {
        Toast.show({
          content: error
        });
      }
      return data;
    },
    *payoutSubmit({ payload }, { call }) {
      const { error, data } = yield call(payoutSubmit, payload);
      if (error) {
        Toast.show({
          content: error
        });
        return false;
      }
      return data;
    },
    *getWithdrawRecordList({ payload }, { call }) {
      const { error, data } = yield call(recordList, payload);
      if (error) {
        Toast.show({
          content: error
        });
        return;
      }
      return data;
    },
    *getShowTask({ payload }, { call }) {
      const { error, data } = yield call(getShowTask, payload);
      if (error) {
        Toast.show({
          content: error
        });
      }
      return data;
    },
    *getGuidanceTask({ payload }, { call, put }) {
      const { error, data } = yield call(getGuidanceTask, payload);
      if (!data && error) {
        Toast.show({
          content: error
        });
        return;
      }
      yield put({
        type: 'updateGuidanceTask',
        payload: data || null
      });
      return data;
    },
    *getAnchorLevelInfo({ payload }, { call, put }) {
      const { error, data } = yield call(getAnchorLevelInfo, payload);
      if (!data && error) {
        Toast.show({
          content: error
        });
        return;
      }
      yield put({
        type: 'updateAnchorLevelInfo',
        payload: data || null
      });
      return data;
    }
  }
};

export default withdraw;
